// Build "light": sem o motor de expressões do lottie-web, que executa o JS
// embutido no arquivo da animação (eval). Telegram proíbe expressões em TGS.
// Vai num chunk separado: só baixa quando a página tem um sticker animado.
let pending = null;
export default function loadLottie() {
  if (!pending) {
    pending = import(/* webpackChunkName: 'common/utils/lottie-web/build/player/lottie_light_canvas', webpackMode: 'lazy-once' */ 'lottie-web/build/player/lottie_light_canvas').then(mod => mod.default || mod).catch(err => {
      pending = null;
      throw err;
    });
  }
  return pending;
}
flarum.reg.add('ramon-stickers', 'common/utils/loadLottie', loadLottie);